import React, { useEffect, useState } from 'react';
import Jazzicon from 'react-jazzicon';
import { ethers } from 'ethers';

// ENS avatar fetcher with Jazzicon fallback
export default function ENSAvatar({ address, size = 32, className = '' }) {
  const [avatar, setAvatar] = useState(null);

  useEffect(() => {
    let isMounted = true;
    async function fetchENS() {
      if (!address || !window.ethereum) return;
      try {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const ensName = await provider.lookupAddress(address);
        if (ensName) {
          const ensAvatar = await provider.getAvatar(ensName);
          if (ensAvatar && isMounted) {
            setAvatar(ensAvatar);
          }
        }
      } catch (e) {
        // ignore
      }
    }
    fetchENS();
    return () => { isMounted = false; };
  }, [address]);

  if (avatar) {
    return <img src={avatar} alt="avatar" width={size} height={size} className={className + ' rounded-full object-cover'} />;
  }
  // fallback Jazzicon
  return <Jazzicon diameter={size} seed={parseInt((address || '0x0').slice(2, 10), 16) || 1} className={className} />;
}
